<template>
  <div id="spacings-page" class="page-wrapper">
    <h1>Spacings</h1>

    <section class="spacing-section">
      <div class="spacing-grid">
        <div v-for="size in spacingSizes" :key="size.name" class="spacing-item">
          <div class="spacing-info">
            <code>${{ size.variable }}</code>
            <span class="spacing-value">{{ size.value }}px</span>
          </div>
          <div class="spacing-visual">
            <div :style="{ width: size.value + 'px' }" class="spacing-bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      spacingSizes: [
        { variable: 'spacing-4xs', value: 2 },
        { variable: 'spacing-3xs', value: 4 },
        { variable: 'spacing-2xs', value: 6 },
        { variable: 'spacing-xs', value: 8 },
        { variable: 'spacing-sm', value: 12 },
        { variable: 'spacing-md', value: 16 },
        { variable: 'spacing-lg', value: 20 },
        { variable: 'spacing-xl', value: 24 },
        { variable: 'spacing-2xl', value: 32 },
        { variable: 'spacing-3xl', value: 40 },
        { variable: 'spacing-4xl', value: 48 },
        { variable: 'spacing-5xl', value: 64 },
        { variable: 'spacing-6xl', value: 80 },
        { variable: 'spacing-7xl', value: 96 },
        { variable: 'spacing-8xl', value: 128 },
        { variable: 'spacing-9xl', value: 160 },
        { variable: 'spacing-10xl', value: 192 },
        { variable: 'spacing-11xl', value: 224 },
        { variable: 'spacing-12xl', value: 256 }
      ]
    }
  }
}
</script>

<style lang="scss">
#spacings-page {
  .spacing-section {
    margin-top: 32px;
  }

  code {
    font-size: 14px !important;
    color: $color-cool-grey-700 !important;
  }

  .spacing-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
  }

  .spacing-item {
    display: flex;
    align-items: center;
    gap: 24px;
  }

  .spacing-info {
    width: 200px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .spacing-value {
      font-size: 14px;
      color: $color-cool-grey-500;
    }
  }

  .spacing-visual {
    flex-grow: 1;
  }

  .spacing-bar {
    height: 24px;
    background-color: #e0e0e0;
    border-radius: 4px;
  }
}
</style>
